<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    mounted() {
        setTimeout(initAnimation, 0);
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/Pages/NewDetail/NewDetail.vue